export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00606.26f56a85.png";